module.exports = __webpack_public_path__ + "img/404Robot_2.e7ae41c.png";